export default __webpack_public_path__ + "static/media/T4.81359614.svg";